(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wholesale-contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var checkbox = document.getElementById('ContactForm-same-as-shipping');
    var billingFields = document.getElementById('ContactForm-billing-fields');

    if (!checkbox || !billingFields) return;

    function toggleBillingFields() {
      billingFields.style.display = checkbox.checked ? 'none' : 'flex';
      billingFields.querySelectorAll('input').forEach(function (input) {
        input.disabled = checkbox.checked;
      });
    }

    checkbox.addEventListener('change', toggleBillingFields);
    toggleBillingFields();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wholesale2-contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var checkbox = document.getElementById('ContactForm-same-as-shipping');
    var billingFields = document.getElementById('ContactForm-billing-fields');

    if (!checkbox || !billingFields) return;

    function toggleBillingFields() {
      billingFields.style.display = checkbox.checked ? 'none' : 'flex';
      billingFields.querySelectorAll('input').forEach(function (input) {
        input.disabled = checkbox.checked;
      });
    }

    checkbox.addEventListener('change', toggleBillingFields);
    toggleBillingFields();
  })();
  } catch(e) { console.error(e); }
})();

})();
